import React, { useEffect, useState } from 'react';
import { GoogleAuthSessionProvider } from './GoogleAuthSessionProvider';

export default function LayoutGadget({ children }) {
  

  return (
    <GoogleAuthSessionProvider>
          {children}
    </GoogleAuthSessionProvider>
  );
}